import type { FC } from "react";

import { ClientDetailsFields } from "../../foreignNationals/components/ClientDetailsFields";

export type ClientError = {
  message: string;
  /** The email belongs to a client already; offer to pick them instead. */
  emailExists: boolean;
};

type Props = {
  error: ClientError | null;
  onUseExistingClient: () => void;
  className?: string;
};

/** The `/clients/new` client form; title, pronouns and the rest stay optional. */
export const NewClientStep: FC<Props> = ({
  error,
  onUseExistingClient,
  className
}) => (
  <>
    <ClientDetailsFields
      emailError={error?.message ?? null}
      className={className}
    />
    {error ? (
      <p className="mt-2 text-sm text-danger">
        {error.message}
        {error.emailExists ? (
          <>
            {" "}
            <button
              type="button"
              onClick={onUseExistingClient}
              className="font-medium text-accent-seed underline underline-offset-2"
            >
              Pick them as an existing client
            </button>
          </>
        ) : null}
      </p>
    ) : null}
  </>
);
